/** @jsxImportSource @emotion/react */
import profileStub from '../../../../assets/images/profilePlaceholder.jpg';

import * as React from 'react';
import * as R from 'ramda';
import { GuestDetails } from '../../../guestDetails';
import { connect } from 'react-redux';
import { IAppState } from '../../../../core/redux/IAppState';
import { Column, Row } from '../../../../layout/flexbox';
import { CIRCULAR_RADIUS } from '../../../guestCard/guestCardStyles';
import { css } from '@emotion/react';
import { GREEN_CREEK, RED_CREEK } from '../../../../styles/colors';
import { fullName } from '../../../module';
import StatusButton from '../../../../forms/elements/StatusButton';
import { doNothing } from '../../../../language/module';
import { XLargeText } from '../../../../styles/styles';
import ErrorView from '../../../../forms/ErrorView';
import { BoxedErrorInverseNoBorder } from '../../../../forms/elements/boxedMessage/boxedMessageStyles';
import { ACTION_TYPE } from '../../../../core/redux/actionType';
import { getLoading } from '../../../../core/redux/api/module';
import LabelGroup from '../../../../forms/elements/LabelGroup';
import { Input } from '../../../../forms/elements/Input';
import { ROW_SPACING } from '../../../../forms/styles';
import { hasPhoto } from '../../../guestPhoto/module';
import { getResource } from '../../../../language/resources/getResource';

const guestLinkStatusButton = css`
  flex-basis: 75px; 
  flex-shrink: 0; 
  user-select: none; 
  cursor: auto;
`

type Props = {
  guestId: string;
  chipId?: string;
  autoFocus?: boolean;
  loadingPhoto?: boolean;
  guest?: GuestDetails;
  resources: Record<string, any>;
  onChipIdUpdate: (chipId: string, guestId: string) => void;
  error?: string;
};


/**
 * GuestLinkRfidSummary: a component that renders an Assoc RFID form as a table row for the group print dialog.
 *
 * PureComponent: true
 * Connected to Redux: true
 */
export default connect(
  (state: IAppState, props: Props) => ({
    guest:        state.guests.get(props.guestId),
    loadingPhoto: !!getLoading(state, props.guestId, ACTION_TYPE.GET_GUEST_PHOTO_REQUEST)
                  || !!getLoading(state, props.guestId, ACTION_TYPE.SET_GUEST_PHOTO_REQUEST),
    resources:    state.locale,
  }),
)(class GuestLinkRfidSummary extends React.PureComponent<Props> {
  private onIdUpdate = (event) => this.props.onChipIdUpdate(
    (R.path<string>([ 'target', 'value' ], event) || '').trim(),
    this.props.guestId,
  );


  public render = () => (
    <Column rootCss={css`padding: 10px 20px;`}>
      <Row alignItems='center' rootCss={ROW_SPACING}>
        <StatusButton width={75}
                      height={75}
                      borderWidth={3}
                      fillMode='fill'
                      borderRadius={CIRCULAR_RADIUS}
                      borderColor={hasPhoto(this.props.guest) ? GREEN_CREEK : RED_CREEK}
                      isLoading={this.props.loadingPhoto!}
                      handleClick={doNothing}
                      toolTipText=""
                      image={
                        R.path([ 'guest', 'photo', 'imgSmall' ], this.props)
                        || R.path([ 'guest', 'photo', 'imgLarge' ], this.props)
                        || profileStub
                      }
                      rootCss={guestLinkStatusButton}/>
        <LabelGroup label={getResource(this.props.resources, 'GUEST_LINK_RFID_LABEL')}>
          <Input type='text'
                 autoFocus={this.props.autoFocus}
                 title={getResource(this.props.resources, 'GUEST_LINK_RFID_INPUT_TITLE')}
                 placeholder={getResource(this.props.resources, 'GUEST_LINK_RFID_INPUT_PLACEHOLDER')}
                 value={this.props.chipId}
                 onChange={this.onIdUpdate}
                 css={css`
                   min-width: 350px;
                   flex-grow: 1;
                 `}/>
        </LabelGroup>
        <span css={XLargeText}>{fullName(this.props.guest!)}</span>
      </Row>
      <ErrorView error={this.props.error}
                 boxStyle={BoxedErrorInverseNoBorder}
                 rootCss={css`
                  user-select: none; 
                  padding-top: 10px;
                 `}/>
    </Column>
  );
});
